// extracted by mini-css-extract-plugin
export var barContainer = "_36-0";
export var extraThin = "_36-3";
export var fillBar = "_36-6";
export var fillContainer = "_36-4";
export var overflow = "_36-8";
export var overflowContainer = "_36-5";
export var regular = "_36-7";
export var thick = "_36-1";
export var thin = "_36-2";